import React from 'react';
import { T, ROLES, HEALTH } from '../../lib/tokens';

/**
 * Unified Badge component with role, health, and priority variants.
 */
export const RoleBadge = ({ roleSlug, small }) => {
  const r = ROLES[roleSlug];
  if (!r) return null;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: small ? '2px 8px' : '3px 10px',
      borderRadius: 20,
      fontSize: small ? 10 : 11,
      fontWeight: 600,
      letterSpacing: '0.03em',
      background: r.light,
      color: r.color,
      border: `1px solid ${r.border}`,
    }}>
      {r.label}
    </span>
  );
};

export const HealthBadge = ({ health, small }) => {
  const h = HEALTH[health];
  if (!h) return null;
  return (
    <span style={{
      display: 'inline-block',
      fontSize: small ? 8 : 9,
      fontWeight: 700,
      letterSpacing: '0.04em',
      padding: small ? '1px 5px' : '2px 7px',
      borderRadius: 4,
      background: h.bg,
      color: h.color,
      border: `1px solid ${h.border}`,
    }}>
      {h.label}
    </span>
  );
};

export const PriorityDot = ({ priority }) => {
  const colors = { 1: T.red, 2: T.amber, 3: T.textLight };
  return (
    <div style={{
      width: 6, height: 6, borderRadius: '50%',
      background: colors[priority] || T.textLight,
      flexShrink: 0,
    }} />
  );
};

export const Pill = ({ children, active, color, bg, border, onClick }) => (
  <button onClick={onClick} style={{
    padding: '5px 14px', borderRadius: 20, fontSize: 13, fontWeight: 500,
    cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s',
    background: active ? (bg || T.amberLight) : 'rgba(0,0,0,0.04)',
    color: active ? (color || T.amber) : T.textMid,
    border: `1px solid ${active ? (border || T.amberBorder) : 'rgba(0,0,0,0.08)'}`,
  }}>
    {children}
  </button>
);
